import { useMutation, useQueryClient } from "react-query";
import { useNotify } from "react-admin";
import gql from "graphql-tag";
import { graphqlFetch } from "../../../lib/graphqlClient";

export interface DeviceInfo {
  brand?: string;
  model?: string;
  os_type?: string;
  os_version?: string;
}

export interface CreateMyGrapariUserInput {
  msisdn: string;
  device_info?: DeviceInfo;
}

export interface CreateMyGrapariUserResponse {
  error?: string;
  status: string;
  user_id?: string;
}

export const useCreateMyGrapariUser = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const mutation = useMutation(
    (variables: { input: CreateMyGrapariUserInput }) =>
      graphqlFetch<CreateMyGrapariUserResponse>({
        query:
          gql`
            mutation createMyGrapariUser($input: CreateMyGrapariUserInput!) {
              createMyGrapariUser(input: $input) {
                error
                status
                user_id
              }
            }
          `.loc?.source?.body || "",
        variables,
      }),
    {
      onSuccess: (data) => {
        const result = (data as any)?.data?.createMyGrapariUser;

        if (result?.error) {
          notify(`Error: ${result?.error}`, { type: "error" });
        } else {
          notify("Subscriber created successfully", { type: "success" });
        }

        queryClient.invalidateQueries(["subscribers"]);
      },
      onError: (error: Error) => {
        notify(`Error creating subscriber: ${error.message}`, { type: "error" });
      },
    }
  );

  return {
    createMyGrapariUser: mutation,
    createMyGrapariUserAsync: (input: CreateMyGrapariUserInput) =>
      mutation.mutateAsync({ input }),
  };
};
